class MetricBox {}

export default MetricBox;
